<template>
  <div>
    <!-- page wrapper start -->
    <div class="pg-wrapper registration-wrapper">
      <app-header /> 
      
      <main class="content-wrapper registration-page-content section-text-dark">
         <div class="container">
           <div class="columns is-gap-40-cols  is-8-widescreen is-multiline is-mobile justify-content-between">
              <div class="column is-gap-40-col is-12-mobile is-12-tablet is-6-widescreen is-6-desktop">
                <Register/>
              </div>

              <div class="column is-gap-40-col is-12-mobile is-12-tablet is-6-widescreen is-6-desktop">
                <Login/>
              </div>
           </div>
         </div>
      </main>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Login from  "@/Components/Pages/PageComponents/Register/Login";
import Register from  "@/Components/Pages/PageComponents/Register/Register";
import Helpers from '@/Components/Helpers/Helpers';

export default {
  name: 'RegisterPage',
  components: {
      Login,
      Register
  },
  data() {
    return {
   
    };
  },

  async mounted() {
    await Helpers.loadFacebookSDK();
    await Helpers.initFacebook(false);
  },

  methods: {
  },
};
</script>

